import { isDevOrPreviewSite } from '../../utils/general'
import { getCurrencySymbol } from '../currency'

const isDev = isDevOrPreviewSite()

const TEAM_MEMBER_PRICE_IDS_BY_SYMBOL = {
  $: isDev ? 'price_1RrKKPKnX1nnNv6I9FYJGO9h' : 'price_1RduFiKnX1nnNv6IeRJuprNV',
  '€': isDev ? 'price_1RrKI9KnX1nnNv6ICR7naD01' : 'price_1Rw6FBKnX1nnNv6IRq5XKRD1',
  '£': isDev ? 'price_1RrKHOKnX1nnNv6IMJi8s7g8' : 'price_1Rw6EmKnX1nnNv6IcS7UFUqI',
  '₹': isDev ? 'price_1RrKLBKnX1nnNv6ITUPNksMP' : 'price_1Rw6HaKnX1nnNv6Iw9QprLUu'
}

const ADDITIONAL_TEAM_MEMBER_PRICING = {
  $: 9,
  '€': 9,
  '£': 7,
  '₹': 500
}

export const DEFAULT_TEAM_LIMIT = 1

export const getTeamMemberPriceIdBySymbol = (currencyInput = '$') => {
  const symbol = getCurrencySymbol(currencyInput)
  return TEAM_MEMBER_PRICE_IDS_BY_SYMBOL[symbol] || TEAM_MEMBER_PRICE_IDS_BY_SYMBOL['$']
}

export const getAdditionalTeamMemberPrice = (currencyInput = '$') => {
  const symbol = getCurrencySymbol(currencyInput)
  return ADDITIONAL_TEAM_MEMBER_PRICING[symbol] || ADDITIONAL_TEAM_MEMBER_PRICING['$']
}
